import PropTypes from 'prop-types';
import Button from '@base/Button/Button';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import Paper from '@base/Paper/Paper';
import { breakpoints, Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import * as React from 'react';
import styled from '@emotion/styled';
import pushRoute from '@utils/pushRoute';

const { SPACING_12B, SPACING_6B, SPACING_10B } = Spacings;

const Container = styled(Paper)`
  grid-column: span 24;
  position: relative;
  margin-top: ${SPACING_6B};
  padding: ${SPACING_12B} ${SPACING_10B};
  background: url(${getImage('free-lesson/banner-bg.svg')}) no-repeat bottom
      right,
    var(--color-base-1);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    background-position: top right;
    padding: ${SPACING_12B} ${SPACING_6B} ${SPACING_10B};
    background-image: url(${getImage('free-lesson/mobile-banner-bg.svg')});
    margin-top: ${Spacings.SPACING_14B};
  }
`;

const Title = styled(H3)`
  color: var(--color-text-primary);
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 169px;
    font-size: 20px;
  }
`;

const SubTitle = styled(H5)`
  color: var(--color-text-primary);
  font-weight: 400;
  margin-top: ${Spacings.SPACING_2B};
  width: 495px;
  display: inline-block;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    font-size: 12px;
    color: var(--color-text-primary);
    margin-top: ${Spacings.SPACING_3B};
  }
`;

const Features = styled.div`
  margin-top: ${Spacings.SPACING_11B};
  width: 495px;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 20px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column-gap: 8px;
    grid-row-gap: 12px;
    width: 100%;
    margin-top: 24px;
  }
  & div:nth-child(even) {
    grid-column: 6/10;
    @media only screen and (max-width: ${breakpoints.mobile}) {
      grid-column: span 10;
    }
  }
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  grid-column: span 4;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    grid-column: span 10;
    & h5 {
      font-size: 14px;
    }
  }
`;

const Img = styled.img`
  user-select: none;
  margin-right: ${Spacings.SPACING_3B};
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 36px;
    height: 36px;
  }
`;

const LearnMore = styled(Button)`
  position: absolute;
  top: 48px;
  right: 40px;
  width: 167px;
  @media only screen and (max-width: ${breakpoints.mobile}) {
    position: relative;
    top: initial;
    right: initial;
    width: 100%;
    margin-top: ${Spacings.SPACING_16B};
    font-size: 14px;
  }
`;

const features = [
  {
    image: getImage('free-lesson/syllabus.svg'),
    title: 'Structured syllabus',
    id: '1'
  },
  {
    image: getImage('free-lesson/notes.svg'),
    title: 'Daily live classes',
    id: '2'
  },
  {
    image: getImage('free-lesson/doubt and solutions.svg'),
    title: 'Ask doubts',
    id: '3'
  },
  {
    image: getImage('free-lesson/tests.svg'),
    title: 'Tests & practice',
    id: '4'
  }
];

function Banner({ goal, className }) {
  const handleClick = () => {
    pushRoute('/goal/[goalSlug]/[goalUID]', `/goal/${goal.slug}/${goal.uid}`);
  };
  return (
    <Container className={className}>
      <Title>{`Crack ${goal?.name || 'Goal'} with Unacademy`}</Title>
      <SubTitle>
        Get subscription and access unlimited live and recorded courses from
        India&#39;s best educators
      </SubTitle>
      <Features>
        {features &&
          features.map((feature) => (
            <Feature key={feature.id}>
              <Img
                src={feature.image}
                alt={feature.title}
                width="30"
                height="30"
              />
              <H5 color="var(--color-text-primary)">{feature.title}</H5>
            </Feature>
          ))}
      </Features>
      <LearnMore label="Learn more" onClick={handleClick} />
    </Container>
  );
}

Banner.propTypes = {
  goal: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string
};

Banner.defaultProps = {
  className: ''
};

export default Banner;
